module.exports = __webpack_public_path__ + "img/camping-1.12ac6652.jpg";